<template>
  <el-popover placement="bottom" v-if="!isSingle" :trigger="trigger" @show="active = true" @hide="active = false">
    <el-row class="filterSelect">
      <el-input v-if="showSearch" v-model.trim="kw" style="width: 150px;" :placeholder="placeholder" suffixIcon="el-icon-search" size="small" clearable></el-input>
      <div class="line" v-if="showSearch"></div>
      <el-scrollbar>
        <div class="filterSelectGroups">
          <el-checkbox-group v-model="data.value" v-if="!isSingle" :min="0">
            <div v-for="(group,index) in option" :key="index">
              <div class="groupName" v-if="group.options">{{group.label}}</div>
              <el-checkbox v-for="(item,index) in group.options" :label="item[props.value]" :key="index" v-if="group.options"><span>{{item[props.label]}}</span></el-checkbox>
              <el-checkbox :label="group[props.value]" :key="index"  v-if="!group.options">{{group[props.label]}}</el-checkbox>
            </div>
          </el-checkbox-group>
          <el-radio-group v-model="data.value" :min="0" v-if="isSingle">
            <div v-for="(group,index) in option" :key="index">
              <div class="groupName" v-if="group.options">{{group.label}}</div>
              <el-radio v-for="(item,index) in group.options" :label="item[props.value]" :key="index" v-if="group.options"><span>{{item[props.label]}}</span></el-radio>
              <el-radio :label="group[props.value]" :key="index" v-if="!group.options">{{group[props.label]}}</el-radio>
            </div>
          </el-radio-group>
        </div>
      </el-scrollbar>
    </el-row>
    <el-button type="text" :class="noBorder && 'noBorder'" class="selectBtn" slot="reference" @click="active = !active" style="color: #4A4A4A;">{{getLabels}}<i class="el-icon--right el-icon-arrow-down dropDown" :class="active && 'active'" ></i></el-button>
  </el-popover>
  <el-select v-else v-model="data.value" :class="noBorder && 'noBorder'" ref="select" placeholder="请选择">
    <el-option-group
      v-for="(group,index) in option" :key="index" :label="group.label" v-if="group.options">
      <el-option
        v-for="item in group.options"
        :key="item[props.value]"
        :label="item[props.label]"
        :value="item[props.value]">
      </el-option>
    </el-option-group>
    <el-option v-for="(group, index) in option" :key="index" :label="group[props.label]" :value="group[props.value]" v-if="!group.options"></el-option>
  </el-select>
</template>
<script>
import skyCheckBox from './sky-checkbox.vue'
import skySelect from './sky-select.vue'
import _ from 'lodash'
export default {
  components: {
    skyCheckBox,
    skySelect
  },
  props: {
    noBorder: true,
    isSingle: {
      default: false,
      type: Boolean
    },
    placeholder: {
      default: '请输入关键字',
      type: String
    },
    title: {
      default: '请选择',
      type: String
    },
    trigger: {
      default: 'click',
      type: String
    },
    showSearch: {
      default: false,
      type: Boolean
    },
    props: {
      default () {
        return {
          label: 'label',
          value: 'value'
        }
      }
    },
    data: {
      default: () => {},
      type: Object
    },
    filterMethod: Function
  },
  data () {
    return {
      icon: '',
      select: this.title || '请选择',
      kw: '',
      active: false,
      originOption: _.cloneDeep(this.data.options) || [],
      option: _.cloneDeep(this.data.options) || []
    }
  },
  computed: {
    getLabels () {
      let select = this.select;
      if (select && select.length && select.length != 0) {
        return select
      } else if (select && select !== '') {
        return select
      }
      return '请选择'
    }
  },
  mounted () {
    this.formatLabel(this.data.value)
  },
  watch: {
    kw (val, oldVal) {
      const options = _.cloneDeep(this.originOption);
      if (typeof this.filterMethod !== 'undefined') {
        this.filterMethod(val, this.option, options);
        return
      }
      if (val !== '') {
        this.option = _.filter(options, item => {
          if (item.options) {
            item.options = _.filter(item.options, value => {
              return value[this.props.label].indexOf(val) !== -1
            })
          }
          return item[this.props.label].indexOf(val) !== -1 || item.options.length > 0
        })
      } else {
        if (val !== oldVal && val === '') {
          this.option = this.originOption
        }
      }
    },
    'data.value' (val) {
      this.formatLabel(val);
    }
  },
  methods: {
    formatLabel (val) {
      if (typeof val === 'string') {
        this.select = this.findLabel(val, this.originOption)
      } else if (_.isArray(val)) {
        this.select = _.map(val, item => this.findLabel(item, this.originOption)).join(', ')
      }
    },
    findLabel (val, list) {
      let result = '';
      let value = this.props.value;
      let label = this.props.label;
      _.each(list, item => {
        if (item && item[value] && val === item[value]) {
          result = item[label]
        } else if (item.options && result === '') {
          result = this.findLabel(val, item.options)
        }
      });
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
  .filterSelect {
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
    font-size: 12px;
    .line {
      height: 1px;
      background: #d4d4d5;
      margin: 10px 0;
    }
    .filterSelectGroups {
      max-height: 210px;
    }
    .groupName {
      color: #bababa;
      display: block;
      font-size: 12px;
      .el-checkbox-group {
        display: block;
        margin: 10px 0 10px 0;
        color: #4a4a4a;
      }
    }
  }
  .dropDown {
    transition: transform .3s;
    transform: rotate(0deg);
  }
  .dropDown.active {
    transform: rotate(-180deg);
  }
  .el-checkbox-group label,.el-radio-group label{
    display: block;
    margin: 10px 0 10px 0;
    color: #4a4a4a;
  }
  .el-checkbox-group label:hover,.el-radio-group label:hover{
    background: #f5f7fa;
  }
  .filterSelectGroups ::v-deep  span {
    font-size: 12px;
  }
  .selectBtn {
    border: 1px solid #dcdfe6;
    padding: 0 15px;
    border-radius: 4px;
  }
  .selectBtn:focus {
    border-color: #409EFF;
  }
  .noBorder ::v-deep  .el-input__inner {
      border: 0;
      padding: 0;
    }
</style>
